var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.value),expression:"value",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.clipboardSuccessHandler),expression:"clipboardSuccessHandler",arg:"success"},{name:"tooltip",rawName:"v-tooltip",value:({
      content: `${_vm.$t('copiedNotif')}`,
      show: _vm.isTooltipOpen,
      trigger: 'manual',
      placement: 'bottom',
    }),expression:"{\n      content: `${$t('copiedNotif')}`,\n      show: isTooltipOpen,\n      trigger: 'manual',\n      placement: 'bottom',\n    }"}],class:_vm.$style.btn,attrs:{"secondary":""}},[_vm._v(" Copy "),_c('BaseIcon',{class:_vm.$style.icon,attrs:{"name":['far', 'clone']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }